import { __extends } from "tslib";
import { IgrColumn } from "./igr-column";
import { ComboBoxColumn } from "./ComboBoxColumn";
/**
 * A combobox column.
*/
var IgrComboBoxColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrComboBoxColumn, _super);
    function IgrComboBoxColumn(props) {
        return _super.call(this, props) || this;
    }
    IgrComboBoxColumn.prototype.createImplementation = function () {
        return new ComboBoxColumn();
    };
    Object.defineProperty(IgrComboBoxColumn.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrComboBoxColumn.prototype, "actualDataSource", {
        /**
         * Gets the actual data source that is being used by the combo. If a collection was provided for the combobox data, an implicit LocalDataSource is created, and this is available via this property.
        */
        get: function () {
            return this.i.kw;
        },
        set: function (v) {
            this.i.kw = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrComboBoxColumn.prototype, "dataSource", {
        /**
         * Gets or sets the ComboBox data source.
        */
        get: function () {
            return this.i.kx;
        },
        set: function (v) {
            this.i.kx = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrComboBoxColumn.prototype, "textField", {
        /**
         * Gets or sets the ComboBox text field.
        */
        get: function () {
            return this.i.k1;
        },
        set: function (v) {
            this.i.k1 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrComboBoxColumn.prototype, "valueField", {
        /**
         * Gets or sets the ComboBox value field.
        */
        get: function () {
            return this.i.ku;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.ku = v;
        },
        enumerable: false,
        configurable: true
    });
    return IgrComboBoxColumn;
}(IgrColumn));
export { IgrComboBoxColumn };
//# sourceMappingURL=igr-combo-box-column.js.map
